import { ModelDataType } from 'src/app/interfaces/model-data-type';
import { State } from 'src/app/interfaces/state';
import { StateFull } from 'src/app/interfaces/state-full';

import { BaseModel } from './base-model';
import { PrimaryTradeLicenseRequirement } from './primary-trade-license-requirement';

export class SubNationalDivision extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static SubNationalDivisionProperties: (
    | {
        property: keyof SubNationalDivision;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof SubNationalDivision;
        type: 'alias';
      }
    | {
        property: keyof SubNationalDivision;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'country', type: 'column', dataType: 'string' },
    { property: 'abbreviation', type: 'column', dataType: 'string' },
    { property: 'name', type: 'column', dataType: 'string' },
    { property: 'launched', type: 'column', dataType: 'boolean' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    {
      property: 'PrimaryTradeLicenseRequirements',
      model: 'PrimaryTradeLicenseRequirement',
      type: 'association'
    }
  ];

  static {
    SubNationalDivision.SubNationalDivisionProperties.forEach(
      (propertyObject) => {
        const { property, type } = propertyObject;
        if (type === 'column') {
          SubNationalDivision.columnMap.set(property, propertyObject);
        }
        if (type === 'alias') {
          SubNationalDivision.aliasedColumnMap.set(
            property,
            propertyObject as { property: string; type: 'alias' }
          );
        }
        if (type === 'association') {
          SubNationalDivision.associationMap.set(
            property,
            propertyObject as {
              property: string;
              type: 'association';
              model: string;
            }
          );
        }
      }
    );
  }

  constructor(SubNationalDivisionObject: Partial<SubNationalDivision>) {
    super();

    SubNationalDivision.SubNationalDivisionProperties.forEach(
      (propertyObject) => {
        const { property } = propertyObject;
        const value = SubNationalDivisionObject[property];
        if (value !== undefined) {
          Object.assign(this, { [property]: value });
        }
      }
    );
  }

  id?: number;
  country?: 'USA' | 'Canada';
  abbreviation?: State;
  name?: StateFull;
  launched?: boolean;
  createdAt?: Date;
  updatedAt?: Date;

  PrimaryTradeLicenseRequirements?: PrimaryTradeLicenseRequirement[];
}
